export default "# Upload 上传\r\n\r\n通用上传。\r\n\r\n用于上传office、图片、pdf等文件。\r\n\r\n## 何时使用\r\n\r\n- ...。";